import { sva } from "@styled-system/css";
import { collapsibleAnatomy } from "@ark-ui/anatomy";

export const collapseStyles = sva({
  slots: collapsibleAnatomy.keys(),
  base: {
    content: {
      overflow: "hidden",
      _open: {
        animation: "slideDown"
      },
      _closed: {
        animation: "slideUp"
      }
    },
    root: {
      w: "100%"
    }
  }
});
